module.exports = __webpack_public_path__ + "images/line_lp/main-content-heading-right_4808195021ee2dd9c80d9b2c6ebc6413.png";